import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ui-list-item, [ui-list-item], ui-list-item[ui-list-item-truncate]',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UIListItemComponent {}
